import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { ActionTableCell, ExTable, ModalButton, TableBody, TableCell, TableHead, TableWrapper } from 'components/shared/widget'
import { Order, OrderSearchForm } from 'entities/order'
import { useDeleteOrderApi, useDownloadOrderListApi, useFetchOrdersApi } from 'api/order'
import { orderColumnInfoList, OrderTableData } from './order_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { EditOrderForm, NewOrderForm } from './order_form'
import { useState } from 'react'
import { SearchConditionView } from 'components/shared/search_drawer'
import { Button, Modal, Table } from 'react-bootstrap'
import { MasterDataContext } from 'contexts/master_data_context'
import { ProbeStockModal } from 'components/probe/probes_modal'
import { Probe } from 'entities/probe'
import { OrderInspectForm, useDeleteOrderInspectionApi, useInspectOrderInspectionApi } from 'api/order_inspection'
import { Flex } from 'components/shared/flex'
import { EditOrderInspectionForm, NewOrderInspectionForm } from 'components/order_inspect/order_inspect_form'
import { OrderInspection } from 'entities/order_inspection'
import { toDateText } from 'utils/util'

type Props = {
    history: H.History
}

const ThermoOrdersPage = (props: Props) => {
    const query = useQuery<OrderSearchForm>()
    const searchForm = useForm<OrderSearchForm>({ ordering: '-order_created_at', ...query })
    const listApi = useFetchOrdersApi(searchForm)
    const globalState = useContext(GlobalStateContext)
    const masterData = useContext(MasterDataContext)
    const orderDisplaySetting = useDisplaySetting(orderColumnInfoList(searchForm), 'Order')
    const deleteApi = useDeleteOrderApi()
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const [selectedOrder, setSelectedOrder] = useState<Order>({})
    const dlOrderListApi = useDownloadOrderListApi()
    const inspectApi = useInspectOrderInspectionApi()
    const inspectForm = useForm<OrderInspectForm>({})
    const [showInspect, setShowInspect] = useState<boolean>(false)
    const [showProbeStocks, setShowProbeStocks] = useState<boolean>(false)
    const [selectedProbe, setSelectedProbe] = useState<Probe>({})
    const [editOrderInspection, setEditOrderInspection] = useState<OrderInspection>({})
    const [showEditOrderInspection, setShowEditOrderInspection] = useState<boolean>(false)
    const deleteOrderInspectionApi = useDeleteOrderInspectionApi()

    useEffect(() => {
        listApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteApi.loading)
        if (deleteApi.isSuccess()) {
            listApi.execute()
        }
    }, [deleteApi.loading])

    const handleClickRemoveFilter = (key: keyof OrderSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(inspectApi.loading)
        if (inspectApi.isSuccess()) {
            listApi.execute()
            setShowInspect(false)
        }
    }, [inspectApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteOrderInspectionApi.loading)
        if (deleteOrderInspectionApi.isSuccess()) {
            listApi.execute()
        }
    }, [deleteOrderInspectionApi.loading])

    return (
        <>
            <EditOrderInspectionForm
                orderInspection={editOrderInspection}
                show={showEditOrderInspection}
                onComplete={() => {
                    setShowEditOrderInspection(false)
                    listApi.execute()
                }}
                onClose={() => setShowEditOrderInspection(false)}
            />
            <ProbeStockModal onClose={() => setShowProbeStocks(false)} show={showProbeStocks} probe={selectedProbe} />
            <EditOrderForm
                show={showEdit}
                order={selectedOrder}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                    listApi.execute()
                }}
            />
            <ContentHeader
                headerTitle="Orders / ThermoFisher"
                left={
                    <>
                        <NewOrderForm onComplete={() => listApi.execute()} />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    <>
                        <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                    </>
                }
            />
            <Modal show={showInspect} onHide={() => setShowInspect(true)}>
                <Modal.Header closeButton>
                    <Modal.Title>納品リスト更新</Modal.Title>
                </Modal.Header>
                <Modal.Body>納品リストを更新しますか？</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setShowInspect(false)
                        }}
                    >
                        閉じる
                    </Button>
                    <Button
                        variant="success"
                        onClick={() => {
                            inspectApi.execute(selectedOrder.id!, inspectForm)
                        }}
                    >
                        更新
                    </Button>
                </Modal.Footer>
            </Modal>
            <ContentBody>
                <TableWrapper>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <ActionTableCell th></ActionTableCell>
                                <TableCell th width={130}></TableCell>
                                <TableCell th width={110}></TableCell>
                                <TableHeads displaySetting={orderDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody loading={listApi.loading}>
                            {listApi.response.results.map((order: Order) => {
                                return (
                                    <tr key={order.id}>
                                        {/* <ActionTableCell
                                            action={'delete'}
                                            onClick={() => {
                                                globalState.showConfirm('本当に削除しますか？', () => {
                                                    deleteApi.execute(order.id!)
                                                })
                                            }}
                                        /> */}
                                        <ActionTableCell
                                            action={'edit'}
                                            onClick={() => {
                                                setSelectedOrder(order)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <TableCell align="center">
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() => {
                                                    dlOrderListApi.execute(order.id!)
                                                }}
                                            >
                                                発注リストDL
                                            </Button>
                                        </TableCell>
                                        <TableCell align="center">
                                            <ModalButton
                                                modalProps={{ size: 'lg' }}
                                                openButton={
                                                    <Button variant="outline-secondary" size="sm">
                                                        納品リスト
                                                    </Button>
                                                }
                                                modalHeader={
                                                    <Flex alignItems="center">
                                                        <div>納品リスト</div>
                                                        <div>
                                                            <NewOrderInspectionForm
                                                                orderId={order.id}
                                                                onComplete={() => {
                                                                    listApi.execute()
                                                                }}
                                                            />
                                                        </div>
                                                    </Flex>
                                                }
                                                modalBody={
                                                    <div>
                                                        <Table style={{ verticalAlign: 'middle' }}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: 50 }}>ID</th>
                                                                    <th style={{ width: 50 }}>Del</th>
                                                                    <th style={{ width: 50 }}>Edit</th>
                                                                    <th>Rack ID</th>
                                                                    <th>Stocks</th>
                                                                    <th>Inspect date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {order.orderInspections?.map((orderInspection) => {
                                                                    return (
                                                                        <tr key={orderInspection.id}>
                                                                            <td>{orderInspection.id}</td>
                                                                            {orderInspection.inspectedAt ? (
                                                                                <>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <ActionTableCell
                                                                                        action="delete"
                                                                                        onClick={() => {
                                                                                            globalState.showConfirm('本当に削除しますか？', () => {
                                                                                                deleteOrderInspectionApi.execute(orderInspection.id!)
                                                                                            })
                                                                                        }}
                                                                                    />
                                                                                    <ActionTableCell
                                                                                        action="edit"
                                                                                        onClick={() => {
                                                                                            setEditOrderInspection(orderInspection)
                                                                                            setShowEditOrderInspection(true)
                                                                                        }}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                            <td>{orderInspection.rackCode}</td>
                                                                            <td>
                                                                                <a
                                                                                    style={{ cursor: 'pointer', color: 'blue' }}
                                                                                    onClick={() => {
                                                                                        setSelectedProbe({ probeStocks: orderInspection.probeStocks })
                                                                                        setShowProbeStocks(true)
                                                                                    }}
                                                                                >
                                                                                    {orderInspection.probeStocks?.length ?? 0}個
                                                                                </a>
                                                                            </td>
                                                                            <td>
                                                                                {orderInspection.inspectedAt ? (
                                                                                    toDateText(orderInspection.inspectedAt)
                                                                                ) : (
                                                                                    <ModalButton
                                                                                        modalHeader={<div>納品</div>}
                                                                                        modalBody={<div>納品リストを更新しますか？</div>}
                                                                                        submitButton={
                                                                                            <Button
                                                                                                variant="success"
                                                                                                onClick={() => {
                                                                                                    inspectApi.execute(orderInspection.id!, inspectForm)
                                                                                                }}
                                                                                            >
                                                                                                納品
                                                                                            </Button>
                                                                                        }
                                                                                        openButton={
                                                                                            <Button
                                                                                                style={{ width: '100%' }}
                                                                                                variant="outline-success"
                                                                                                size="sm"
                                                                                                onClick={() => {}}
                                                                                            >
                                                                                                納品
                                                                                            </Button>
                                                                                        }
                                                                                    />
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                }
                                            />
                                        </TableCell>
                                        <OrderTableData
                                            order={order}
                                            displaySetting={orderDisplaySetting}
                                            onClickStocks={(probeStocks) => {
                                                setSelectedProbe({ probeStocks: probeStocks })
                                                setShowProbeStocks(true)
                                            }}
                                        />
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(ThermoOrdersPage)
